/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IScrollIntoViewData } from './scroll-into-view.data';
import { IScrollIntoViewProps } from './scroll-into-view.props.autogenerated';

export interface IScrollIntoViewViewProps extends IScrollIntoViewProps<IScrollIntoViewData> {}

/**
 *
 * ScrollIntoView component
 * @extends {React.PureComponent<IScrollIntoViewProps<IScrollIntoViewData>>}
 */
class ScrollIntoView extends React.PureComponent<IScrollIntoViewProps<IScrollIntoViewData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default ScrollIntoView;
